import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [NgbModule, ScrollingModule],
  declarations: [],
  exports: [],
})
export class MainModule {}
